import React from 'react';
import PropTypes from 'prop-types';

import {
  AttachmentErrorWrapper,
} from './styles';
import texts from './texts.json';

const AttachmentError = ({
  children,
}) => (
  <AttachmentErrorWrapper>
    {children}
  </AttachmentErrorWrapper>
);

AttachmentError.propTypes = {
  children: PropTypes.node,
};

AttachmentError.defaultProps = {
  children: texts.genericError,
};

export default AttachmentError;
